"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const styled_components_1 = require("styled-components");
const Brand_1 = require("components/images/Brand");
const Containers_1 = require("components/styled/Containers");
const ScreenSizes_1 = require("components/styled/ScreenSizes");
const Nav = styled_components_1.default.div `
  width: 100%;
  position: relative;
  z-index: 1;

  ${ScreenSizes_1.TABLET_PORTRAIT} {
    position: absolute;
  }
`;
const Link = styled_components_1.default.a `
  text-decoration: none;
`;
exports.Navbar = () => {
    return (React.createElement(Nav, null,
        React.createElement(Containers_1.NavContent, null,
            React.createElement(Link, { target: "_blank", href: "https://www.stellar.org/" },
                React.createElement(Brand_1.SvgBrand, null)))));
};



// WEBPACK FOOTER //
// ./src/components/styled/Navbar.tsx